import { Switch } from 'antd';
import type { IPayoutReport } from 'api/invoices/payout/types';
import type { TComponent } from 'utils/types/component';

interface IEnabledCellProps {
    identity: string;
    scheduling: IPayoutReport['scheduling'];
    onToggleEnabled: (identity: string, checked: boolean) => void;
}

export const EnabledCell: TComponent<IEnabledCellProps> = (props) => {
    const { identity, onToggleEnabled, scheduling } = props;

    if (!scheduling) {
        return <>-</>;
    }

    const isEnabled = scheduling.enabled;

    const handleToggleEnabled = (checked: boolean) => {
        onToggleEnabled(identity, checked);
    };

    return <Switch checked={isEnabled} onChange={handleToggleEnabled} />;
};
